import { Injectable } from '@angular/core';
import {LoadingController,Events} from 'ionic-angular';

import { Http, RequestOptions, URLSearchParams ,Headers } from '@angular/http';
import {ToastController} from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import { GVLogger } from '../services/gv-logger';
import { DatabaseProvider } from '../providers/database/database';
import {AppConfig, ApplicationVariables} from '../providers/config';
import { TokenManager } from '../providers/token-manager';
import { Constants } from '../providers/config';
import { Network } from '@ionic-native/network';
import {CommonDataProvider} from "./common-data/common-data";

@Injectable()
export class ApiOffline {

 cust = {
    id : 1,
    name : "test1",
    phone : "34789743743"
  };

	loaderControll:any;


	rtApiURL: string = '';
  dtApiURL: string =  '';
	loaderFlag = true;
	requests:string[] = [
	"customers/searchAll"
	];
  offlineCustomers: any;
  offlineCustomerss: Promise<any>;
  data1: any;
  itemsCount = 0;


  constructor(
  	private gVLogger:GVLogger,
  	private databaseProvider:DatabaseProvider,
  	private toastCtrl:ToastController,
  	private http:Http,
  	private tokenManager:TokenManager,
  	private loadingCtrl:LoadingController,
    public commonDataProvider:CommonDataProvider,
    private events:Events,
    private network:Network) {

    if(!Constants.isWebstore)
    {

      // this.databaseProvider.openDatabase();
  	  // this.databaseProvider.createCustomersTable();
    }
  }

  setURL(){
    if(this.commonDataProvider.countryCode === '+92'){
      this.gVLogger.log('setURL +92 ----- ');
      this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_PK"];
      this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_PK"];
    }
    else if(this.commonDataProvider.countryCode === '+1') {
      this.gVLogger.log('setURL +1 ----- ');
      this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_NA"];
      this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_NA"];

    }
    else if(this.commonDataProvider.countryCode === '')
    {
      this.gVLogger.log('setURL 0 ----- ');
      this.dtApiURL =  AppConfig.LOCAL_DTAPI_PK;
      this.rtApiURL =  AppConfig.LOCAL_RTAPI_PK;
    }
    else{

    }


    /*this.storage.get('countryCode').then((countryCode)=>{


      if(countryCode === '+92'){
        this.gVLogger.log('setURL +92 ----- ')
        this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_PK"];
        this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_PK"];
      }
      else if(countryCode === '+1') {
        this.gVLogger.log('setURL +1 ----- ')
        this.dtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_DTAPI_NA"];
        this.rtApiURL =  AppConfig[AppConfig.ENVIRONMENT+"_RTAPI_NA"];
        this.gVLogger.log(this.dtApiURL, this.rtApiURL);
      }
      else if(countryCode === 0)
      {
        this.gVLogger.log('setURL 0 ----- ')
        this.dtApiURL =  AppConfig.LOCAL_DTAPI_PK;
        this.rtApiURL =  AppConfig.LOCAL_RTAPI_PK;
      }
      else{
        if(countryCode === null)
          alert(countryCode+"    CountryCode is null");

        this.gVLogger.log('setURL --- countryCode --- ', countryCode)
      }
    });*/
  }

  get(endpoint: string, params?: any, options?: RequestOptions) {


	  	if(endpoint.indexOf("customers/search")!== -1){
	  		// break the rtApiURL and get the 3rd param as query and 4th as offset
	  		// alert(" end point........!!!!!!!!! " + endpoint);

	  		var res = endpoint.split("/");
	  		this.gVLogger.log(res);
	  		var query = res[2];
	  		var offset = res[3];

        // alert("end point........!!!!!!!!! " + endpoint + query + offset);


	  		// response = '{\r\n\t\"status\": \"200\",\r\n\t\"message\": \"Offline DATA\",\r\n\t\"data\": [{\r\n\t\t\"id\": 1,\r\n\t\t\"customerId\": \"2965\",\r\n\t\t\"name\": \"007 DESIGN 01\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"NH01\"\r\n\t}, {\r\n\t\t\"id\": 2,\r\n\t\t\"customerId\": \"2C2966\",\r\n\t\t\"name\": \"2 CRAZY LADIES EVENT PLANNING\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"email\": \"atieq.geoviz@gmail.com\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"ISON\"\r\n\t}, {\r\n\t\t\"id\": 409,\r\n\t\t\"customerId\": \"CO5823\",\r\n\t\t\"name\": \"2Co. Design Build Inc\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"SBON\"\r\n\t}, {\r\n\t\t\"id\": 3,\r\n\t\t\"customerId\": \"5T4337\",\r\n\t\t\"name\": \"5th Elements Events\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"SBON\"\r\n\t}, {\r\n\t\t\"id\": 27,\r\n\t\t\"customerId\": \"AD6317\",\r\n\t\t\"name\": \"A Day in May Event Planning \\u0026 Design\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"ISUS\"\r\n\t}, {\r\n\t\t\"id\": 34,\r\n\t\t\"customerId\": \"AH5806\",\r\n\t\t\"name\": \"A Home Inspired\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"SBON\"\r\n\t}, {\r\n\t\t\"id\": 58,\r\n\t\t\"customerId\": \"AL7111\",\r\n\t\t\"name\": \"A Little Inspiration\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"ISUS\"\r\n\t}, {\r\n\t\t\"id\": 97,\r\n\t\t\"customerId\": \"AP5416\",\r\n\t\t\"name\": \"A Passion For Living\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"RLON\"\r\n\t}, {\r\n\t\t\"id\": 98,\r\n\t\t\"customerId\": \"AP8033\",\r\n\t\t\"name\": \"A Pinch Of Creativity\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"BWSK\"\r\n\t}, {\r\n\t\t\"id\": 127,\r\n\t\t\"customerId\": \"AS5809\",\r\n\t\t\"name\": \"A Set Above\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"SGON\"\r\n\t}, {\r\n\t\t\"id\": 500,\r\n\t\t\"customerId\": \"DE4449\",\r\n\t\t\"name\": \"A\\u0026C Lifestyle\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"ISEC\"\r\n\t}, {\r\n\t\t\"id\": 4,\r\n\t\t\"customerId\": \"AA5813\",\r\n\t\t\"name\": \"Aakriti Designs\",\r\n\t\t\"phone\": \"444556666\",\r\n\t\t\"locationsDTOs\": [],\r\n\t\t\"productCommentsDTOs\": [],\r\n\t\t\"wishlistsDTOs\": [],\r\n\t\t\"logedinUser\": 0,\r\n\t\t\"customerStatus\": 1,\r\n\t\t\"userStatus\": 0,\r\n\t\t\"userId\": 0,\r\n\t\t\"adpCustomerId\": 0,\r\n\t\t\"salesPersonCode\": \"RLON\"\r\n\t}]\r\n}';

			// response = JSON.parse(response);

      // this.searchCustomers(query,offset).then((data) => {
      //   alert("length in api offline/......." + data.rows.length)
      // });
      return this.searchCustomers(query,offset);


	  		// .then(result => {

		   //      for(var i=0; i<result.rows.length; i++)
		   //      {
		   //          var json = JSON.parse(result.rows.item(i).json);
		   //          response.data.push(json);
		   //         //alert(result.rows.item(i).json);
		   //      }
		  	// 	alert(JSON.stringify(response));
		  	// 	return response;
		   //  })
		   //  .catch(e => alert("caught: "+JSON.stringify(e)));

	  	}else{
	  		return null;

	  	}

  }

  post(endpoint: string, body: any, options?: RequestOptions) {

  }

  put(endpoint: string, body: any, options?: RequestOptions) {

  }

  deletePost(endpoint: string, body: any, options?: RequestOptions) {

  }

  patch(endpoint: string, body: any, options?: RequestOptions) {

  }
  delete(endpoint: string, body: any, options?: RequestOptions) {

  }



  searchCustomers(query,offset){
    // alert("search customer in api-offline called");
  	return this.databaseProvider.searchCustomers(query,offset);
  }






  syncCustomersFromCloud(itemcount){



	return new Promise(resolve=>{



			if(this.loaderFlag){
				this.loaderFlag = false;
				this.loaderControll = this.loadingCtrl.create({
				      content:"Loading Customers..."
				    });
				    this.loaderControll.present();

			}

        this.gVLogger.log("After loaderFlag----->");
		  	let searchQuery = " ";

		  	let itemCount = itemcount;

		  	let headers = new Headers({ 'token': this.tokenManager.getToken()});
        let options = new RequestOptions({ headers: headers });
        // this.gVLogger.log("getToken()----->>>", this.tokenManager.getToken());
        // this.gVLogger.log("headers----->>>>>", headers);
		  	var url = this.rtApiURL + "/customers/lazy/"+itemCount;
		    // get list items of a category as sample
		    this.http.get(url, options).map(res => res.json())
		    .subscribe(data => {
		    	// alert("DATA: "+JSON.stringify(data));
          // this.gVLogger.log("After loaderFlag dataaaaaaaa----->");
		    	let toast = this.toastCtrl.create({
					      message: "success",
					      duration: 50
					    });
					  //  toast.present();
            // this.gVLogger.log("After loaderFlag dataaaaaaaa----->");
          var promises = [];


        for(let cust of data.data)
        {
          // alert("insert customer" + this.cust)
          this.gVLogger.log("After loaderFlaggggg dataaaaaaaa----->");

        var p = this.databaseProvider.insertIntoCustomers(cust)
         .then((data) => {
           this.data1 = data;
          //  alert(this.data1.rowsAffected);
         })
          // alert("result" + p);

          promises.push(p);

        }

          // Promise.all(promises).then(value =>
          // {
            if(data.data.length > 0)

            {
              // alert("recursive function called" + data.data.length);
		    			// let toast = this.toastCtrl.create({
					    //   message: itemCount + data.data.length + " items saved",
					    //   duration: 3000
					    // });
		    			this.syncCustomersFromCloud(itemCount+data.data.length);
            }
            else if(data.data.length <= 0)
            {
		    			let toast = this.toastCtrl.create({
					      message: itemCount+data.data.length + " customers saved. ",
					      duration: 3000
					    });
					    toast.present();
              // this.loaderFlag = true;
              this.loaderFlag = false;
					    this.loaderControll.dismiss();
					    this.syncCategoriesFromCloud();
              this.syncProductsFromCloud();
              this.getAllOfflineCustomers();
		    			resolve(true);
		    		}
			  // },err=>{alert("error of promise all" + err)});
		    },
			error=>{
				resolve(false);
				// alert(JSON.stringify(error));
			});

	  	});

  }


  syncCategoriesFromCloud(){

    // alert("syncCategoriesFromCloud called");

  	let headers = new Headers({ 'token': this.tokenManager.getToken()});
    let options = new RequestOptions({ headers: headers });

	var url = this.rtApiURL + "/collection/all";

    this.http.get(url, options)
        .map(res => res.json())
        .subscribe(result => {
            if(result.status == 200)
            {
                // alert("result of syncCatagories" + JSON.stringify(result));
                //alert(JSON.stringify(result));
                let json = JSON.stringify(result);
                this.databaseProvider.insertIntoCategories(json);

            }
        });


  }


  syncProductsFromCloud(){
    // alert("syncProductsFromCloud fuction called" );
  	this.loaderControll = this.loadingCtrl.create({
				      content:"Loading Products..."
				    });
				    this.loaderControll.present();
  		// this.loaderControll.present();
		let productCount = 0;
        this.getProductsRecursive(productCount);

  }


  getProductsRecursive(productCount)
    {
      // alert("product count" + productCount);
        return new Promise(resolve => {

            let headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('token',  this.tokenManager.getToken());
            let options = new RequestOptions({ headers: headers });

            // let body = {"collection":[0],"subCollection":[0],"categories":[0],"tags":[0]};
            let body = {"collection":[0],"subCollection":[0],"categories":[0],"tags":[0], searchQuery: "", attributeFilter: []};


            let url = this.rtApiURL + "/products/productsByCollectionsClassesAndTags/"+productCount+"/0?isWebStore=1"; // UD
            // let url = this.rtApiURL + "/products/searchProductsByCollectionsClassesAndTags/"+productCount+"/3634?isWebStore=0";
            this.http.post(url, body, options)
                .map(res=>res.json())
                .subscribe(data =>{
                    let json = JSON.stringify(data.data.attributeMenu);
                    this.databaseProvider.insertAttributes( json );

                  // this.gVLogger.log("products data from adp server" + data);
                  // alert("Enter in getting products subscribe" + data.data);
                  // alert("legth of the products from adp server" + data.data.productsDTOs.length);
                  // alert("legth of the products from adp server" + JSON.stringify( data.data));
                        if(data.data.productsDTOs=="undefined")
                            this.gVLogger.log("un un undefined");

                        if(data.data.productsDTOs.length>0)
                        {
                            for(let i=0; i<data.data.productsDTOs.length; i++)
                            {
                                this.gVLogger.log(data.data.productsDTOs[i]);
                                let id = data.data.productsDTOs[i].id;
                                let name = data.data.productsDTOs[i].name;
                                let description = data.data.productsDTOs[i].description;
                                let barcode = data.data.productsDTOs[i].barCode;
                                let collectionId = data.data.productsDTOs[i].categoryId;
                                let subCollectionId = data.data.productsDTOs[i].subCategoryId;
                                let classId = data.data.productsDTOs[i].classId;
                                let json = JSON.stringify(data.data.productsDTOs[i]);
                                this.databaseProvider.insertProduct(id, name, description,barcode, collectionId, subCollectionId, classId, json );
                            }
                            productCount = productCount + 12;
                            this.getProductsRecursive(productCount);
                            this.itemsCount += data.data.productsDTOs.length + 1;
                        }
                        else
                        {
                          // if(productCount <= 12){
                          //   let toast = this.toastCtrl.create({
                          //     message: productCount + " products saved. ",
                          //     duration: 3000
                          //   });
                          //   toast.present();
                          // }
                          // else {
                            let toast = this.toastCtrl.create({
                              message: this.itemsCount + " products saved. ",
                              duration: 3000
                            });
                            toast.present();
                          // }

                        	this.events.publish("DATASYNCCOMPLETE");

                          this.loaderControll.dismiss();
                        }
                        resolve(true);
                    },
                    err =>{
                        // alert(JSON.stringify(err));
                    });
        });
    }


    getProductsOffline(collectionAndClasses,offset,searchQuery){
    	// alert("offline collections test" + collectionAndClasses + " OFFFSet " + offset + " searchQuery " + searchQuery);
     return	this.databaseProvider.getProductsByLazyLoadNew(collectionAndClasses.collection, collectionAndClasses.subCollection, collectionAndClasses.categories, offset,searchQuery);
    }

  getCategories(){
  	return this.databaseProvider.getCategories();
  }

  getAllOfflineCustomers(){
  	// alert("Getting DATA");
  	this.databaseProvider.fetchFromCustomers().then((res)=>{
      // alert(JSON.stringify(res) + "customers");
      this.offlineCustomers = res;
  	},err=>{
  		// alert(JSON.stringify(err) + "error while getting fline customers");
  	})
  }


  getCustomerById(cid){
   return this.databaseProvider.getCustomerById(cid);
  }

  getAllProducts(){
    this.databaseProvider.getAllProducts().then((res)=>{
      // alert(JSON.stringify(res));
    },err=>{
      // alert(JSON.stringify(err));
    });
  }

  getAttributes(){
    return this.databaseProvider.getAttributes();
  }

  getProductFromBarcode(barcode){
  	return this.databaseProvider.getProductByBarcode(barcode);
  }

  searchProducts(query,offset){
  	return this.databaseProvider.searchProducts(query,offset);
  }


  insertOrder(orderJson){
  	return this.databaseProvider.insertOrder(orderJson);
  }

  getAllOrders(){
  	return this.databaseProvider.getAllOrders();
  }


  syncOrdersToServer(){

    this.loaderControll = this.loadingCtrl.create({
              content:"Checking Internet..."
            });
            this.loaderControll.present();

    setTimeout(()=>{
        if (ApplicationVariables.connectionType == 'wifi' || ApplicationVariables.connectionType == "2g"|| ApplicationVariables.connectionType == "3g"|| ApplicationVariables.connectionType == "4g"|| ApplicationVariables.connectionType == "cellular") {
          this.loaderControll.dismiss();
      this.loaderControll = this.loadingCtrl.create({
              content:"Syncing Orders..."
            });
            this.loaderControll.present();
      this.loaderControll.present();
      this.syncOrders();
    }else{
      this.loaderControll.dismiss();
      let toast = this.toastCtrl.create({
                    message: "Please connect to internet to proceed.",
                    duration: 3000
                  });
                 toast.present();

    }

      },3000);

  }

  syncOrders()
    {
        let promise = this.databaseProvider.getOrder();
        promise.then(result => {
            let orderObject:any = result;
            if(orderObject)
            {
                let orderId = orderObject.id;
                let orderBody = orderObject.order;
                let promise = this.syncOrder(orderId, orderBody);
                promise.then(success=>{

                },
                fail =>{
                  this.loaderControll.dismiss();
                  let toast = this.toastCtrl.create({
                        message: "Error while syncing orders.",
                        duration: 3000
                      });
                     toast.present();
                  this.events.publish("SyncCompleted");
                });
            }else{
            	this.loaderControll.dismiss();
              this.events.publish("SyncCompleted");
            }

        })
            // .catch(e =>alert(JSON.stringify(e)))
    }




  syncOrder(orderId, orderBody)
    {
        return new Promise((resolve,reject) => {
            let headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('token',  this.tokenManager.getToken());
            let options = new RequestOptions({ headers: headers });

            let body = orderBody;

            let url = this.rtApiURL + "/order/place";
            this.http.post(url, body, options)
                .map(res=>res.json())
                .subscribe(data =>{
                    if(data.status == 200)
                    {
                        this.databaseProvider.deleteOrderById(orderId);
                       // alert("Synced Order: "+orderId);
                    }else{
                      reject(true);
                    }
                    if(data.status == 200){
                      this.syncOrders();
                      resolve(true);
                    }
                },
                err =>{
                    reject(true);
                    this.gVLogger.log(err);
                });
        });
    }



    checkDataAvailablie(){

      return new Promise((resolve,reject)=>{
        this.databaseProvider.getAllCustomers().then((customers)=>{
            if (customers.rows.length > 0) {
              resolve(true);
            }else{
              reject(true);
            }
        },
        err=>{
          reject(true);
        });
      });


    }



    isInternetConnected(){

      return new Promise((resolve,reject)=>{
          this.http.post(this.rtApiURL + "/imageUploader/auth"+"?token="+this.tokenManager.getToken(),null).map(res =>res.json()).subscribe(res=>{
           // alert(JSON.stringify(res));
            resolve(true);
          },err=>{
             reject(true);
          });
      });
    }



    deleteOfflineData(){
      return new Promise((resolve,reject)=>{
        this.gVLogger.log("Promise resolver/Reject-------");
            this.databaseProvider.truncateCustomersTable().then(res=>{
              this.gVLogger.log("truncateCustomersTable-----");
              this.databaseProvider.truncateCategoriesTable().then(res=>{
                this.gVLogger.log("truncateCategoriesTable");
                this.databaseProvider.truncateProductsTable().then(res=>{
                  this.gVLogger.log("truncateProductsTable");
                  resolve(true);
                },err=>{
                  // alert(JSON.stringify(err));
                  reject(true);
                })
              },err=>{
                // alert(JSON.stringify(err));
                reject(true);
              })
            },err=>{
              // alert(JSON.stringify(err));
              reject(true);
            })
          });
    }
}



// WEBPACK FOOTER //
// ./src/providers/api-offline.ts